"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashTypes = exports.AesTypes = exports.Standard = exports.Pbkdf2 = exports.hash = exports.aes = void 0;
var aes_1 = require("./aes");
Object.defineProperty(exports, "aes", { enumerable: true, get: function () { return aes_1.Index; } });
const standard_1 = require("./standard");
Object.defineProperty(exports, "Standard", { enumerable: true, get: function () { return standard_1.Index; } });
const pbkdf2_1 = require("./pbkdf2");
Object.defineProperty(exports, "Pbkdf2", { enumerable: true, get: function () { return pbkdf2_1.Index; } });
exports.hash = { Pbkdf2: pbkdf2_1.Index, Standard: standard_1.Index };
var AesTypes;
(function (AesTypes) {
    AesTypes["cbc"] = "aes-cbc";
    AesTypes["gcm"] = "aes-gcm";
    AesTypes["ctr"] = "aes-ctr";
    AesTypes["cfb"] = "aes-cfb";
    AesTypes["ecb"] = "aes-ecb";
    AesTypes["ofb"] = "aes-ofb";
})(AesTypes || (exports.AesTypes = AesTypes = {}));
var HashTypes;
(function (HashTypes) {
    HashTypes["standard"] = "hmac256";
    HashTypes["pbkdf2"] = "pbkdf2";
})(HashTypes || (exports.HashTypes = HashTypes = {}));
//# sourceMappingURL=index.js.map